
// src/actions/pins.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'
import actions from '../actions'

export const PIN_DIARY = "PIN_DIARY"
export const PIN_DIARY_REQUESTED = "PIN_DIARY_REQUESTED"
export const PIN_DIARY_COMPLETED = "PIN_DIARY_COMPLETED"
export const PIN_DIARY_FAILED = "PIN_DIARY_FAILED"

export function pinDiaryRequested() {
  return {
    type: PIN_DIARY_REQUESTED
  }
}

export function pinDiary(diary_id) {
  return function(dispatch) {
    dispatch(pinDiaryRequested())
    return api.post(`/pins`, { diary_id })
        .then((results)=> {
          dispatch(pinDiaryCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(pinDiaryFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function pinDiaryCompleted(results) {
  return {
    type: PIN_DIARY_COMPLETED,
    results,
  }
}

export function pinDiaryFailed(error) {
  return {
    type: PIN_DIARY_FAILED,
    error,
  }
}

export const UNPIN_DIARY = "UNPIN_DIARY"
export const UNPIN_DIARY_REQUESTED = "UNPIN_DIARY_REQUESTED"
export const UNPIN_DIARY_COMPLETED = "UNPIN_DIARY_COMPLETED"
export const UNPIN_DIARY_FAILED = "UNPIN_DIARY_FAILED"

export function unpinDiaryRequested() {
  return {
    type: UNPIN_DIARY_REQUESTED
  }
}

export function unpinDiary(diary_id, group_id) {
  return function(dispatch) {
    dispatch(unpinDiaryRequested())
    return api.delete(`/pins/${diary_id}`)
        .then((results)=> {
          dispatch(unpinDiaryCompleted(results))
          dispatch(actions.fetchDiaries(group_id, 0))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(unpinDiaryFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function unpinDiaryCompleted(results) {
  return {
    type: UNPIN_DIARY_COMPLETED,
    results,
  }
}

export function unpinDiaryFailed(error) {
  return {
    type: UNPIN_DIARY_FAILED,
    error,
  }
}



// WEBPACK FOOTER //
// ./src/actions/pins.js